export default __webpack_public_path__ + "static/media/Group 403.9077b48f.png";